import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Fa from 'react-fontawesome';
import {
  Button, FormGroup, ControlLabel, FormControl,
  HelpBlock, Collapse, Tabs, Tab, Dropdown, MenuItem,
} from 'react-bootstrap';
import pluralize from 'pluralize';
import { Link, Redirect, Prompt } from 'react-router-dom';
import { keys, find, delay, reduce, trimEnd, each, values,
  isArray, cloneDeep, startsWith, reject } from 'lodash';
import Joi from 'joi';
import Toggle from 'react-bootstrap-toggle';
import draftToHtml from 'draftjs-to-html';
import { CompositeDecorator, EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import { Field, reduxForm, formValueSelector, SubmissionError, getFormValues } from 'redux-form';
import moment from 'moment';

import Editor from '../../../../components/editor';
import SearchForm from '../../../../components/search-form';
import { getSearchQuery, cleanSubmitCriteria, getIsDirty } from '../../../../components/search-form/search-form-reducer';
import { checkDirty } from '../../../../components/search-form/search-form-actions';
import ProgressBar from '../../../../components/progress-bar';
import OpportunityOwnerField from './OpportunityOwnerField';
import AccountOwnerField from './OpportunityAccountOwnerField';
import OpportunityStatusField from './OpportunityStatusField';
import CopyQueryControl from './CopyQueryControl';
import AutomationTestModal from './AutomationTestModal';
import ContactTriggerOptions from './ContactTriggerOptions';
import CRMInstanceName from '../../../../components/crm-instance-name';
import ModifiedLog from './ModifiedLog';
import ResetTextControl from './ResetTextControl';
import SenderList from './SenderList';
import ResellerList from './ResellerList';


import {
  fetchFeedbackRequestAutomation,
  updateFeedbackRequestAutomation,
  createFeedbackRequestAutomation,
  fetchDiscoveryBotLogs,
} from '../../SetupActions';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { getFooterHeight } from '../../../App/AppReducer';

import styles from './styles.css';

const formNames = [
  'automations/discovery-bot',
  'automations/discovery-bot/window',
  'automations/discovery-bot/contacts/opportunity_contacts',
  'automations/discovery-bot/contacts/account_contacts',
  'automations/discovery-bot/contacts/contacts_with_activities',
  'automations/discovery-bot/contacts/custom_contact_object_references',
  'automations/discovery-bot/contacts/gong_contacts',
  'automations/discovery-bot/contacts/gong',
];

const isContactForm = (name) => {
  return startsWith(name, 'automations/discovery-bot/contacts/');
}
const contactFormType = (name) => {
  return name.replace('automations/discovery-bot/contacts/', '');
}

const getValidFormNames = (organization, autoOpenRequestWindow = false, automationType) => {
  let fns = [...formNames];

  if (!organization.has_gong_contacts) {
    fns = reject(fns, (fn) => {
      return fn.indexOf('gong') >= 0;
    });
  }
  /*
  if (!autoOpenRequestWindow || automationType === 'manual') {
    fns = reject(fns, (fn) => {
      return fn.indexOf('window') >= 0;
    });
  }
  */

  // reject contact forms if automationType !== 'full'

  return fns;
}

const getFormInfos = (organization, settings) => {
  const stateFormInfos = reduce(getValidFormNames(organization, settings.auto_open_request_window, settings.automation_type), (items, formName) => {
    items[formName] = {
      query: null,
      ready: false,
    };
    if (isContactForm(formName)) {
      const type = contactFormType(formName);
      const q = find(settings.contact_conditions, { type });
      if (q) {
        items[formName].query = q.query;
      } else {
        items[formName].query = {};
      }
    }
    return items;
  }, {});
  stateFormInfos['automations/discovery-bot'].query = settings.search_query || {};
  if (stateFormInfos['automations/discovery-bot/window']) {
    stateFormInfos['automations/discovery-bot/window'].query = settings.open_window_search_query || {};
  }

  return stateFormInfos;
}

class FeedbackRequestAutomationPage extends Component {
  constructor(props) {
    super(props);
    const { type } = props.match?.params;
    const automationSource = type === 'accounts' ? 'account' : 'opportunity';
    const isAccount = automationSource === 'account';

    this.state = {
      loading: false,
      loaded: false,
      copied: false,

      formInfos: reduce(getValidFormNames(props.organization, false, 'manual'), (items, formName) => {
        items[formName] = {
          query: null,
          ready: false,
        };
        return items;
      }, {}),

      selectedTab: 'searchForm',
      formUpdate: 0,
      sticky: false,
      runTest: false,
      focus: false,
      editorState: null,
      settings: {},
      logs: [],
      selectedLog: null,
      errors: null,
      automationSource,
      isAccount,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onToggleEnable = this.onToggleEnable.bind(this);
    this.renderField = this.renderField.bind(this);
    this.onCopy = this.onCopy.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.handleCloneQuery = this.handleCloneQuery.bind(this);
    this.checkDirty = this.checkDirty.bind(this);
    this.runTest = this.runTest.bind(this);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.renderEditor = this.renderEditor.bind(this);
    this.resetInstructions = this.resetInstructions.bind(this);
    this.forceReload = this.forceReload.bind(this);
    this.handleSearchReady = this.handleSearchReady.bind(this);
    this.handleSyncLookbackChange = this.handleSyncLookbackChange.bind(this);
    this.handleSelectedLogChange = this.handleSelectedLogChange.bind(this);
    this.decorators = [];
  }

  componentDidMount() {
    this.mounted = true;
    this.fetchData();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.automationType !== this.props.automationType && nextProps.automationType !== 'manual') {
      this.setState({ selectedTab: 'searchForm' });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
    this.destroyStickyFooter();
  }

  onEditorStateChange(editorState = null) {
    this.setState({
      editorState,
    });
    const string = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    this.props.change('instructions', string);
  }

  handleFocus() {
    this.setState({ focus: true });
  }

  handleBlur() {
    this.setState({ focus: false });
  }

  onToggleEnable() {
    const { enabled } = this.props;
    this.props.change('enabled', !enabled);
  }

  onCopy() {
    this.setState({ copied: true }, () => {
      delay(() => {
        this.setState({ copied: false });
      }, 2000);
    });
  }

  forceReload(e) {
    e.preventDefault();
    e.stopPropagation();
    window.location.reload();
  }

  checkDirty() {
    each(getValidFormNames(this.props.organization, this.props.autoOpenRequestWindow, this.props.automationType), (formName) => {
      this.props.dispatch(checkDirty(formName), isContactForm(formName));
    });
  }

  handleTabSelect(selectedTab) {
    this.setState({ selectedTab });
  }

  handleSearchReady(type) {
    const newState = { ...this.state.formInfos, [type]: {
      query: this.state.formInfos[type]?.query || {},
      ready: true,
    } };
    this.setState({ formInfos: newState }, () => {
      this.checkDirty();
    });
  }

  handleCloneQuery(query) {
    const newState = {
      ...this.state.formInfos,
      'automations/discovery-bot/window': {
        ...this.state.formInfos['automations/discovery-bot/window'],
        query,
        ready: false,
      },
    };
    this.setState({ formInfos: newState, formUpdate: this.state.formUpdate + 1 }, () => {
      this.props.change('_open_window_search_query', this.state.formUpdate + 1);
      this.checkDirty();
    });
  }

  setInstructionsBody(string) {
    const compositeDecorator = new CompositeDecorator(this.decorators);
    const s = string === '<p></p>\n' ? '<p>.</p>' : string;

    const contentBlock = convertFromHTML(s);
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks, contentBlock.entityMap);
    const editorState = EditorState.createWithContent(contentState, compositeDecorator);

    this.setState({ editorState });
    return editorState;
  }

  resetInstructions() {
    this.onEditorStateChange(this.setInstructionsBody(this.state.settings.$default_instructions));
  }

  prepareDate(settings) {
    if (settings) {
      this.setInstructionsBody(settings.instructions);
      return {
        ...settings,
        syncLookback: `${settings.sync_lookback_period} ${settings.sync_lookback_unit}`,
      };
    }
  }

  splitSyncLookback(syncLookback) {
    if (syncLookback) {
      const pieces = syncLookback.split(' ');
      if (pieces.length === 2) {
        return {
          sync_lookback_period: parseInt(pieces[0], 10),
          sync_lookback_unit: pieces[1],
        };
      }
    }
    return null;
  }

  handleSyncLookbackChange(e) {
    const { value } = e.currentTarget;
    const r = this.splitSyncLookback(value);
    if (r) {
      this.props.change('sync_lookback_period', r.sync_lookback_period);
      this.props.change('sync_lookback_unit', r.sync_lookback_unit);
    }
  }

  handleSubmit(params) {
    const { formInfos, settings } = this.state;
    const propFormInfos = this.props.formInfos;

    params.full_automation_lookback_period = Number.parseInt(params.full_automation_lookback_period, 10);
    params.auto_open_request_window = params.auto_open_request_window === true || params.auto_open_request_window === 'true';
    params.session_id = this.props.sessionId;

    // return error if none of the search form is ready
    
    // TODO: filter formInfos according to
    // params.automation_type: manual, partial, full
    // and params.auto_open_request_window

    /*
    const errors = [];
    const validFormNames = getValidFormNames(this.props.organization, params.auto_open_request_window, params.automation_type);
    console.clear();
    console.log('params.auto_open_request_window', params.auto_open_request_window);
    console.log('params.automation_type', params.automation_type);
    console.log('validFormNames', validFormNames)

    each(formInfos, (info, formType) => {
      if (!info.ready) {
        errors.push(`${contactFormType(formType)}: Form is not ready`);
      }
    });

    if (errors.length) {
      const r = new Error(errors.join('. '));
      const el = (<div>{r.message} Please try again.</div>);
      this.context.addNotification(el, { type: 'error', autoClose: false });
      //throw new SubmissionError(r);
      //return;
    }
    */


    // if the form is not loaded and they hit the save button, just save the previous query
    if (formInfos['automations/discovery-bot']?.ready) {
      params.search_query = cleanSubmitCriteria(propFormInfos['automations/discovery-bot']?.query);
    } else {
      params.search_query = { ...settings.search_query };
    }

    if (formInfos['automations/discovery-bot/window']?.ready) {
      params.open_window_search_query = cleanSubmitCriteria(propFormInfos['automations/discovery-bot/window']?.query);
    } else {
      params.open_window_search_query = { ...settings.open_window_search_query };
    }

    const contactConditions = reduce(settings.contact_conditions, (items, cc) => {
      items[cc.type] = cc;
      return items;
    }, {});

    // we should save all the forms, even if it was disabled
    each(getValidFormNames(this.props.organization, true, 'full'), (formName) => {
      if (isContactForm(formName)) {
        const fType = contactFormType(formName);
        if (formInfos[formName]?.ready) {
          contactConditions[fType] = {
            type: fType,
            query: cleanSubmitCriteria(propFormInfos[formName]?.query),
          };
        } else {
          const q = find(settings.contact_conditions, { type: fType }); // the search form is not ready, they cannot change any criateria, just use the provious data
          if (q) {
            const newQuery = { ...q };
            delete newQuery._id;
            contactConditions[q.type] = newQuery;
          }
        }
      }
    });

    params.contact_conditions = values(contactConditions);


    params.source = this.state.automationSource; // important

    const newSettings = { ...params };
    delete newSettings.all_contact_roles;
    delete newSettings.all_contact_reference_fields;

    delete newSettings.sync_lookback_period;
    delete newSettings.sync_lookback_unit;
    const r = this.splitSyncLookback(newSettings.syncLookback);
    if (r) {
      newSettings.sync_lookback_period = r.sync_lookback_period;
      newSettings.sync_lookback_unit = r.sync_lookback_unit;
    }

    newSettings.sender_conditions = reduce(cloneDeep(params.sender_conditions), (items, sc, order) => {
      items.push({
        order: order + 1,
        query: sc.query,
        field: sc.field,
      });
      return items;
    }, []);

    const { id } = this.props.match.params;
    const isNew = id === undefined || id === null || id === 'new';

    const p1 = isNew ? this.props.dispatch(createFeedbackRequestAutomation(newSettings)) : this.props.dispatch(updateFeedbackRequestAutomation(id, newSettings));

    const p2 = new Promise((resolve) => {
      delay(() => {
        resolve(true); // the "saving" run too fast, it won't show the spinner
      }, 2000);
    });

    return p1.then(
      (settings) => {
        const currentFormInfos = { ...this.state.formInfos };
        const newFormInfos = getFormInfos(this.props.organization, settings);
        each(newFormInfos, (newFormInfo, k) => {
          if (currentFormInfos[k]) {
            newFormInfo.ready = currentFormInfos[k].newFormInfo;
          }
        });
        this.setState({
          formUpdate: this.state.formUpdate + 1,
          formInfos: newFormInfos,
          settings,
        }, () => {
          this.props.initialize(this.prepareDate(settings));
          this.checkDirty();
          this.fetchLogs();
        });
        p2.then(
          () => {
            const el = (<div>Settings updated successfully</div>);
            this.context.addNotification(el, { type: 'success', autoClose: true });
            if (isNew) {
              // redirect ?
              const uri = trimEnd(this.props.location.pathname, '/new');
              this.context.router.history.replace(`${uri}/${settings._id}`);
            }
          },
        );
      },
      (errors) => {
        const e = errors.data || errors;
        const message = e.message || 'Unknown errors - Code: 1123';
        const el = (<div>{message}</div>);
        this.context.addNotification(el, { type: 'error', autoClose: true });
        throw new SubmissionError(e);
      },
    );
  }

  runTest() {
    this.setState({ runTest: true });
  }

  initStickyFooter() {
    if (this.footerRef && this.sentinalRef) {
      this.observer = new window.IntersectionObserver((records) => {
        if (!records[0].isIntersecting) {
          this.setState({ sticky: true });
        } else {
          this.setState({ sticky: false });
        }
      });
      this.observer.observe(this.sentinalRef);
    }
  }

  destroyStickyFooter() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  fetchData() {
    const { id, type } = this.props.match.params;
    const { dispatch } = this.props;
    const isNew = id === undefined || id === null || id === 'new';
    this.setState({ loading: true, loaded: false });

    dispatch(fetchFeedbackRequestAutomation(type, isNew ? 'NEW' : id))
      .then(
        (settings) => {
          if (settings) {
            if (this.mounted) {
              this.props.initialize(this.prepareDate(settings));
              this.setState({
                loading: false,
                loaded: true,
                formInfos: getFormInfos(this.props.organization, settings),
                settings,
              }, () => {
                this.initStickyFooter();
                this.fetchLogs()
              });
            }
          } else if (this.mounted) {
            this.setState({ loading: false, loaded: false, formInfos: {}, errors: { message: 'Not found' } });
          }
        },
        (error) => {
          if (this.mounted) {
            // redirect
            this.setState({ loading: false, loaded: false, formInfos: {}, error });
          }
        },
      );
  }

  fetchLogs() {
    const { id } = this.props.match.params;
    return new Promise((logsResolve, logsReject) => {
      // this.props.dispatch(fetchDiscoveryBotLogs({ id, minimumDate: moment().subtract(3, 'month').format() }))
      this.props.dispatch(fetchDiscoveryBotLogs({ id }))
        .then((logs) => {
          const sortedLogs = logs?.sort((a, b) => new Date(b.date) - new Date(a.date)) || [];
          this.setState({ logs: sortedLogs });
          logsResolve(sortedLogs);
        }, (error) => {
          logsReject(error);
        },
      );
    });
  }

  renderEditor({
    label, editorState, focus, meta: { touched, error },
  }) {
    const validationState = touched && error ? 'error' : null;
    const btn = [
      <ResetTextControl key="reset-btn" onReset={this.resetInstructions} />,
    ];

    return (
      <FormGroup validationState={validationState} className={styles.descriptionEditor}>
        <ControlLabel>{label}</ControlLabel>
        <Editor
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          wrapperClassName={styles.editorWrapper}
          editorClassName={`${styles.editor} ${focus ? styles.editorFocus : ''}`}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          toolbar={{
            options: [
              'inline', 'blockType', 'fontSize',
              'fontFamily', 'list', 'textAlign', 'colorPicker',
              'link', 'emoji', 'remove', 'history',
            ],
            inline: {
              options: ['bold', 'italic', 'underline', 'strikethrough', 'superscript', 'subscript'],
            },
          }}
          toolbarCustomButtons={btn}
          customDecorators={this.decorators}
          readOnly={this.state.selectedLog !== null || this.props.isDeleted}
        />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderField({
    input, label, type, meta: { touched, error }, componentClass, placeholder, options, disabled,
  }) {
    const { submitting, isDeleted } = this.props;
    const { selectedLog } = this.state;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        {label !== null && label !== undefined && label.length > 0 && <ControlLabel>{label}</ControlLabel>}
        {componentClass !== 'select' && <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={submitting || disabled || selectedLog !== null || isDeleted} />}
        {componentClass === 'select' &&
          <FormControl {...input} componentClass={componentClass} placeholder={(placeholder || label)} type={type} disabled={submitting || disabled || selectedLog !== null || isDeleted}>
            {options !== null && options !== undefined && options.map(option => (<option key={option.value} value={option.value}>{option.label}</option>))}
          </FormControl>
        }
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  renderCopyQueryControl() {
    const { submitting } = this.props;
    const { selectedLog, isAccount } = this.state;
    const openWindowSearchQuery = this.state.formInfos['automations/discovery-bot/window']?.query || null;
    const hasQuery = (openWindowSearchQuery && openWindowSearchQuery.values && openWindowSearchQuery.values.length > 0);
    return (
      <div className={hasQuery ? 'pull-right' : 'pull-left'}>
        <div className="clearfix">
          {!hasQuery && <small style={{ display: 'inline-block', paddingTop: '7px' }} className="text-muted">&nbsp;OR&nbsp;</small>}
          <CopyQueryControl
            key="control"
            isAccount={isAccount}
            currentId={this.props.match.params.id}
            disabled={submitting || selectedLog !== null}
            shouldConfirm={hasQuery}
            onDone={this.handleCloneQuery}
            fromQuery={this.props.formInfos['automations/discovery-bot']?.query}
          />
        </div>
      </div>
    );
  }

  getMainFormInnerFields() {
    const {
      submitting,
      ownerMustBeEnabled,
      bypassInvitation,
      opportunityStatus,
      opportunityFromExternalOwner,
      isDeleted,
    } = this.props;
    const { isAccount, automationSource, selectedLog } = this.state;

    const innerFields  = [];
    innerFields.push((
      <div key="one" style={{ marginBottom: '10px' }}>
        <OpportunityOwnerField
          value={bypassInvitation ? ownerMustBeEnabled : true}
          path={[]}
          level={1}
          showDelete={false}
          showInclude={false}
          disabled={submitting || selectedLog !== null || isDeleted}
          isAccount={isAccount}
          editable={bypassInvitation}
          searchCriteria={{
            _id: 'owner-enabled',
            type: 'include',
            filter: {
              _id: 'owner-enabled-filter',
              label: isAccount ? 'Account Owner' : 'Opportunity Owner',
            },
          }}
          onChange={(value) => {
            this.props.change('owner_must_be_enabled', bypassInvitation ? value : true);
          }}
          searchType="automations/discovery-bot"
          onUpdate={() => {}}
        />
      </div>
    ));

    if (!isAccount) {
      innerFields.push((
        <div key={`${automationSource}-two`} className="animated fadeIn" >
          <OpportunityStatusField
            value={opportunityStatus}
            path={['opportunity_status']}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting || selectedLog !== null || isDeleted}
            searchCriteria={{
              _id: 'opportunity-status',
              type: 'include',
              filter: {
                _id: 'opportunity-status',
                label: 'Opportunity Status',
              },
            }}
            onChange={this.props.change}
            searchType="automations/discovery-bot"
            onUpdate={() => {}}
          />
        </div>
      ));
    } else {
      innerFields.push((
        <div key={`${automationSource}-two`} className="animated fadeIn" >
          <AccountOwnerField
            value={opportunityFromExternalOwner}
            path={['opportunity_owner']}
            level={1}
            showDelete={false}
            showInclude={false}
            disabled={submitting || selectedLog !== null || isDeleted}
            searchCriteria={{
              _id: 'opportunity-owner',
              type: 'include',
              filter: {
                _id: 'opportunity-owner',
                label: 'Opportunity/Deal owner',
              },
            }}
            onChange={(v) => {
              this.props.change('full_automation_opportunity_from_external_owner', v);
            }}
            searchType="automations/discovery-bot"
            onUpdate={() => {}}
          />
        </div>
      ));
    }
    return innerFields;
  }

  getOpenWindowFormInnerFields() {
    const {
      submitting,
      openWindowOwnerMustBeEnabled,
      bypassInvitation,
      isDeleted,
    } = this.props;
    const { isAccount, selectedLog } = this.state;

    const innerFields  = [];
    innerFields.push((
      <div key="one" style={{ marginBottom: '10px' }}>
        <OpportunityOwnerField
          value={bypassInvitation ? openWindowOwnerMustBeEnabled : true}
          path={[]}
          level={1}
          showDelete={false}
          showInclude={false}
          disabled={submitting || selectedLog !== null || isDeleted}
          isAccount={isAccount}
          editable={bypassInvitation}
          searchCriteria={{
            _id: 'owner-enabled',
            type: 'include',
            filter: {
              _id: 'owner-enabled-filter',
              label: isAccount ? 'Account Owner' : 'Opportunity Owner',
            },
          }}
          onChange={(value) => {
            this.props.change('open_window_owner_must_be_enabled', bypassInvitation ? value : true);
          }}
          searchType="automations/discovery-bot/window"
          onUpdate={() => {}}
        />
      </div>
    ));

    return innerFields;
  }

  handleSelectedLogChange(log) {
    const settings = log?.settings || this.state.settings;
    this.props.initialize(this.prepareDate(settings));
    delay(() => {
      this.setState({
        selectedLog: log,
        formUpdate: this.state.formUpdate + 1,
        formInfos: getFormInfos(this.props.organization, settings)
      });
    }, 200);
    
  }

  renderSearchForm(type, description = null) {
    const { submitting, isDeleted } = this.props;
    const {
      formInfos,
      formUpdate,
      selectedLog,
    } = this.state;
    let query = formInfos[type]?.query || {};

    let customFooterControls = null;
    let innerFields = null;

    if (type === 'automations/discovery-bot') {
      innerFields = this.getMainFormInnerFields();
    } else if (type === 'automations/discovery-bot/window') {
      customFooterControls = this.renderCopyQueryControl();
      innerFields = this.getOpenWindowFormInnerFields();
    }

    if (keys(query).length === 0) {
      query = {};
    }

    return (
      <div>
        {description !== null && <div className="well well-sm"><Fa name="info-circle" /> {description}</div>}
        <SearchForm
          key={`form-${formUpdate}`}
          dropup
          onSearchChange={() => {
            this.handleSearchReady(type);
          }}
          disabled={submitting || selectedLog !== null || isDeleted}
          standalone
          defaultCriteria={query}
          simpleMode
          type={type}
          className={styles.field}
          showRootLogicalORWarning
          customFooterControls={customFooterControls}
        >
          {innerFields}
        </SearchForm>
      </div>
    );
  }

  renderCustomInstructions() {
    const { focus, editorState } = this.state;
    return (
      <Field
        label="Feedback Request Instructions"
        name="instructions"
        focus={focus}
        editorState={editorState}
        component={this.renderEditor}
      />
    )
  }

  renderFeedbackRequestWindow() {
    const {
      autoOpenRequestWindow,
    } = this.props;

    const automationWindowTypes = [
      { value: true, label: 'Enabled' },
      { value: false, label: 'Disabled' },
    ];
    return (
      <div>
        <Field
          label="Feedback Request Window"
          name="auto_open_request_window"
          componentClass="select"
          options={automationWindowTypes}
          component={this.renderField}
        />
        {!autoOpenRequestWindow && <HelpBlock>In <CRMInstanceName />, the Feedback Request Window will NOT automatically open when an opportunity is closed.</HelpBlock>}
        {autoOpenRequestWindow && this.renderSearchForm('automations/discovery-bot/window', <span>In <CRMInstanceName />, the Feedback Request Window will automatically open when an opportunity is closed that meets the Field &amp; Value trigger conditions below:</span>)}
        {autoOpenRequestWindow && <hr />}
        {autoOpenRequestWindow && this.renderCustomInstructions()}
      </div>
    );
  }

  renderSyncLookbackPeriod() {
    // const { isAccount } = this.state;
    const { sync } = this.props;

    // const body = isAccount ? this.renderAccountBaseSyncLookbackPeriod() : this.renderOpportunityBaseSyncLookbackPeriod();
    const body = this.renderOpportunityBaseSyncLookbackPeriod();

    return (
      <Collapse in={sync}>
        <div style={{ borderLeft: '3px solid #ccc', padding: '5px 10px', marginTop: '10px', marginBottom: '10px' }}>
          {body}
        </div>
      </Collapse>
    );
  }

  renderAccountBaseSyncLookbackPeriod() {
    const { syncLookbackPeriod } = this.props;
    const val = parseInt(syncLookbackPeriod, 10);

    const lookbackOptions = [
      { value: 'days', label: val === 1 ? 'Day' : 'Days' },
      { value: 'weeks', label: val === 1 ? 'Week' : 'Weeks' },
      { value: 'months', label: val === 1 ? 'Month' : 'Months' },
    ];

    return (
      <div>
        <ControlLabel>Lookback Period:</ControlLabel>
        <div className="clearfix">
          <div className="pull-left">
            <Field
              name="sync_lookback_period"
              component={this.renderField}
            />
          </div>
          <div className="pull-left">
            <Field
              name="sync_lookback_unit"
              componentClass="select"
              options={lookbackOptions}
              component={this.renderField}
            />
          </div>
        </div>
      </div>
    );
  }

  renderOpportunityBaseSyncLookbackPeriod() {
    const lookbackOptions = [
      { value: '1 days', label: 'One Day' },
      { value: '1 weeks', label: 'One Week' },
      { value: '2 weeks', label: 'Two Weeks' },
      { value: '1 months', label: 'One Month' },
      { value: '3 months', label: 'Three Months' },
      { value: '6 months', label: 'Six Months' },
      { value: '12 months', label: 'One Year' },
      { value: '18 months', label: 'Eighteen Months' },
      { value: '24 months', label: 'Two Years' },
      { value: '36 months', label: 'Three Years' },
      { value: '48 months', label: 'Four Years' },
      { value: '60 months', label: 'Five Years' },

      { value: '72 months', label: 'Six Years' },
      { value: '84 months', label: 'Seven Years' },
      { value: '96 months', label: 'Eight Years' },
      { value: '108 months', label: 'Nine Years' },
      { value: '120 months', label: 'Ten Years' },
    ];
    return (
      <Field
        label="Lookback Period:"
        name="syncLookback"
        componentClass="select"
        options={lookbackOptions}
        component={this.renderField}
        onChange={this.handleSyncLookbackChange}
      />
    );
  }

  renderDailySyncToggle() {
    const { submitting, sync, isDeleted } = this.props;
    const { selectedLog } = this.state;
    const options = [
      {
        value: true,
        label: 'Check opportunities during daily data sync',
        description: 'Daily data sync will check opportunities that have changed since the last sync for feedback requests. If an opportunity qualifies and no contacts have been submitted, contacts will automatically be submitted based on your contact submit conditions.',
      },
      {
        value: false,
        label: 'Do not check opportunities during daily data sync',
        description: 'Daily data sync will not check opportunities for feedback requests.',
      },
    ];
    return (
      <FormGroup>
        <ControlLabel>Daily Sync:</ControlLabel>
        {options.map((option) => {
          const active = option.value === sync;
          return (
            <div key={option.value} style={{ paddingLeft: '15px' }}>
              <div
                style={{ cursor: (submitting || selectedLog !== null || isDeleted) ? 'not-allowed' : 'pointer' }}
                onClick={() => {
                  if (!submitting && selectedLog === null && !isDeleted) {
                    this.props.change('sync', option.value)
                  }
                }}
              >
                <Fa name={active ? 'check-square' : 'square-o'} className={active ? 'text-success' : ''} /> {option.label}
              </div>
              {active && option.description !== undefined &&
                <HelpBlock>{option.description}</HelpBlock>
              }
              {option.value === true && this.renderSyncLookbackPeriod()}
            </div>
          );
        })}
      </FormGroup>
    );
  }

  renderModifiedLogDropdown() {
    const { logs, settings, selectedLog } = this.state;

    return (
      <Dropdown id="modified-log-dropdown" dropup>
        <Dropdown.Toggle bsStyle="link" bsSize="sm">
          <span className="text-active">
            <ModifiedLog value={selectedLog !== null ? selectedLog.settings : settings} historical={selectedLog !== null} />
            {' '}
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ maxHeight: 300, overflowY: 'auto' }}>
          {logs.map((log, index) => {
            const historical = index !== 0; // hmm?
            const items = [
              ...(historical ? [] : [(<MenuItem header key="header">Current Settings:</MenuItem>)]),
              (
                <MenuItem
                  key={log._id}
                  eventKey={log._id}
                  active={this.state.selectedLog?._id === log._id}
                  onClick={() => this.handleSelectedLogChange(historical ? log : null)}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<ModifiedLog value={log.settings} muted={false} historical={historical} />
              </MenuItem>
              ),
              ...(historical ? [] : [(<MenuItem divider key="div" />), (<MenuItem header key="header2">Historical Settings:</MenuItem>)]),
            ];
            return items;
          })}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderUnsaveWarningMessage(isDirty) {
    const { submitting } = this.props;
    const { selectedLog } = this.state;

    if (submitting || !isDirty || selectedLog !== null) {
      return null;
    }
    return (
      <span className="text-danger animated flash" style={{ paddingTop: 5 }}>
        <Fa name="exclamation-triangle" /> You have unsaved data.
        <Prompt message="You have unsaved changes, are you sure you want to leave?" />
      </span>
    );
  }

  renderCollectorSelector() {
    const { validCollectors, selectedTVCollectorId } = this.props;
    // const { selectedLog } = this.state;
    // const hasValidCollectors = validCollectors.length > 0;
    const allCollectors = reduce(validCollectors, (items, item) => {
      items.push({
        value: item.collector_id,
        label: item.is_active ? item.collector_name : `${item.collector_name} (inactive)`,
      });
      return items;
    }, [{
      value: null,
      label: 'Select TruVoice survey collector',
    }]);

    const selectedCollector = selectedTVCollectorId ? find(validCollectors, { collector_id: selectedTVCollectorId }) : null;
    // const hasValidCollectors = selectedLog || (selectedCollector && selectedCollector.is_active); // viewing log?

    return (
      <div>
        {allCollectors.length > 0 &&
          <Field
            label="Survey Collector"
            name="tv_collector_id"
            componentClass="select"
            options={allCollectors}
            component={this.renderField}
          />
        }

        {validCollectors.length === 0 &&
          <div className="alert alert-danger">
            <Fa name="exclamation-triangle" /> There was a problem while loading survey collectors. Please <a href="" onClick={this.forceReload}>click here</a> to reload this page.
          </div>
        }

        {selectedCollector && !selectedCollector.is_active &&
          <div className="text-danger">
            <Fa name="exclamation-triangle" /> Collector <strong>{selectedCollector.collector_name}</strong> is inactive.
          </div>
        }
      </div>
    );
  }

  renderContent() {
    const {
      handleSubmit,
      submitting,
      automationType,
      valid,
      footerHeight,
      dirty,
      senderConditions,
      organization,
      autoOpenRequestWindow,
      isDeleted,
      resellers,
      enabled,
    } = this.props;

    const {
      selectedTab,
      settings,
      isAccount,
      logs,
      selectedLog,
      formUpdate,
    } = this.state;

    const validFormNames = getValidFormNames(organization, autoOpenRequestWindow);

    const isDirty = dirty || reduce(validFormNames, (items, formName) => {
      return items || (this.state.formInfos[formName]?.ready && this.props.formInfos[formName]?.isDirty);
    }, false);

    /*
    const isReady = reduce(validFormNames, (items, formName) => {
      return items && this.state.formInfos[formName]?.ready;
    }, true);
    */
    const isReady = true; // need to redo this

    const automationTypes = [
      { value: 'manual', label: 'No Automation', description: 'No opportunity qualification checks occur. Contacts can be submitted for feedback for all opportunities.'},
      { value: 'partial', label: 'Opt-in Automation (sales rep selects contacts to submit)', description: 'Users can submit contacts for opportunities that meet the Field & Value trigger conditions set below.'},
      { value: 'full', label: 'Opt-out Automation (TruSales submits contacts and sales rep can review and cancel outreach)', description: 'TruSales will automatically submit contacts for opportunities, using the Contact Submit Conditions settings, that meet the Field & Value trigger conditions set below.'},
    ];

    const activeAutomationType = find(automationTypes, { value: automationType });

    let dateRangeLabel = null;
    if (this.props.syncLookbackPeriod && this.props.syncLookbackUnit) {
      dateRangeLabel = `within the past ${this.props.syncLookbackPeriod} ${pluralize(this.props.syncLookbackUnit, this.props.syncLookbackPeriod)}`;
    }

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <div className={`panel panel-default ${styles.panel}`}>
          <div className="panel-heading">
            <Link to="/setup/feedback-requests/automations"><Fa name="arrow-left" /> Feedback Request Automations </Link>
          </div>
          <div className={`panel-body ${styles.panelBody} ${(this.state.sticky ? styles.sticky : '')}`}>
            <div className="alert alert-warning">
              {isAccount &&
                <div>
                  Automation checks Accounts/Companies
                </div>
              }
              {!isAccount &&
                <div>
                  Automation checks Opportunities/Deals
                </div>
              }
            </div>
            {selectedLog !== null && <div className="alert alert-danger">
              <Fa name="exclamation-triangle" /> You are currently viewing a historical log. The form is in read-only mode, and no changes can be made.
            </div>}
            {isDeleted && <div className="alert alert-danger">
              <Fa name="exclamation-triangle" /> This automation was deleted. The form is in read-only mode, and no changes can be made.
            </div>}
            

            
            <Field
              label="Automation Group Label"
              name="name"
              component={this.renderField}
              key={formUpdate}
            />
            <p>&nbsp;</p>




            <FormGroup>
              <ControlLabel>Feedback Requests</ControlLabel>
              {' '}
              <Toggle
                onClick={this.onToggleEnable}
                on={<span>Enabled</span>}
                off={<span>Disabled</span>}
                onstyle="success"
                size="xs"
                offstyle="danger"
                active={enabled}
                disabled={submitting || selectedLog !== null}
              />
              <HelpBlock>
                {enabled && <div>Feedback can be requested based on the settings below.</div>}
                {!enabled && <div>Feedback requests are disabled in TruSales and <CRMInstanceName />.</div>}
              </HelpBlock>
            </FormGroup>
            <p>&nbsp;</p>

            {this.renderCollectorSelector()}
            <p>&nbsp;</p>



            <Collapse in>
              <div>
                <Field
                  label="Automation Type"
                  name="automation_type"
                  componentClass="select"
                  options={automationTypes}
                  component={this.renderField}
                  key={formUpdate}
                />
                {activeAutomationType !== undefined && <HelpBlock>{activeAutomationType.description}</HelpBlock>}

                <div>
                  <Tabs
                    activeKey={(selectedTab || 'searchForm')}
                    onSelect={this.handleTabSelect}
                    id="discovery-bot-form-tabs"
                    animation={false}
                    key={formUpdate}
                  >
                    <Tab
                      eventKey="searchForm"
                      title="Trigger Conditions"
                    >
                      <div style={{ padding: 15, border: '1px solid #eee' }}>
                        {this.renderSearchForm('automations/discovery-bot', `Only ${isAccount ? 'accounts/companies' : 'opportunities/deals'} that match the filter(s) below will be eligible for feedback requests:`)}
                      </div>
                    </Tab>

                    {automationType === 'full' &&
                      <Tab
                        eventKey="contactForm"
                        title="Contact Submit Conditions"
                      >
                        <div style={{ padding: 15, border: '1px solid #eee' }}>
                          <ContactTriggerOptions
                            key={formUpdate}
                            allRoles={this.state.settings.all_contact_roles}
                            allContactReferenceFields={this.state.settings.all_contact_reference_fields}
                            activityTypes={this.props.activityTypes}
                            contactTypes={this.props.contactTypes}
                            opportunityContactTypes={this.props.opportunityContactTypes}
                            contactRoles={this.props.contactRoles}
                            contactReferenceFields={this.props.contactReferenceFields}
                            contactFromExternalAccount={this.props.contactFromExternalAccount}
                            dateRangeLabel={dateRangeLabel}
                            fullAutomationSingleOpportunity={this.props.fullAutomationSingleOpportunity}
                            gongRequireOpportunityOwner={this.props.gongRequireOpportunityOwner}
                            disabled={submitting || selectedLog !== null || isDeleted}
                            submitting={submitting}
                            isAccount={isAccount}
                            onChange={this.props.change}
                            requestShowSyncTab={() => { this.handleTabSelect('sync'); }}
                            onSearchReady={this.handleSearchReady}
                            formInfos={this.state.formInfos}
                          />
                        </div>
                      </Tab>
                    }
                    {(automationType === 'full' || automationType === 'partial') &&
                      <Tab
                        eventKey="sender"
                        title="Sender Settings"
                      >
                        <div style={{ padding: 15, border: '1px solid #eee' }}>
                          <SenderList
                            senderConditions={senderConditions}
                            isAccount={isAccount}
                            onChange={(v) => {
                              this.props.change('sender_conditions', v);
                            }}
                            disabled={submitting || selectedLog !== null || isDeleted}
                          />
                        </div>
                      </Tab>
                    }

                    {(automationType === 'full' || automationType === 'partial') &&
                      <Tab
                        eventKey="resellers"
                        title="Email Recipients"
                      >
                        <div style={{ padding: 15, border: '1px solid #eee' }}>
                          <ResellerList
                            resellers={resellers}
                            isAccount={isAccount}
                            onChange={(v) => {
                              this.props.change('resellers', v);
                            }}
                            disabled={submitting || selectedLog !== null || isDeleted}
                          />
                        </div>
                      </Tab>
                    }

                    {(automationType === 'full' || automationType === 'partial') &&
                      <Tab
                        eventKey="requestWindow"
                        title="Feedback Request Window"
                      >
                        <div style={{ padding: 15, border: '1px solid #eee' }}>
                          {this.renderFeedbackRequestWindow()}
                        </div>
                      </Tab>
                    }


                    {automationType === 'full' &&
                      <Tab
                        eventKey="sync"
                        title="Daily Sync"
                      >
                        <div style={{ padding: 15, border: '1px solid #eee' }}>
                          {this.renderDailySyncToggle()}
                        </div>
                      </Tab>
                    }
                  </Tabs>
                </div>

              </div>
            </Collapse>
          </div>
          <div
            ref={(el) => { this.footerRef = el; }}
            className={`panel-footer ${styles.panelFooter} ${(this.state.sticky ? styles.sticky : '')}`}
            style={{ bottom: `${footerHeight}px` }}
          >
            <div className="clearfix">
              {isReady &&
                <div className="pull-left">
                  <Button bsStyle="default" disabled={!valid || submitting} onClick={this.runTest}>
                    Run Test
                  </Button>
                </div>
              }
              <div className="pull-left" style={{ padding: '5px 10px' }}>
                {logs?.length > 1
                  ? this.renderModifiedLogDropdown()
                  : <ModifiedLog value={settings} />
                }
              </div>
              {(selectedLog === null && !isDeleted) &&
                <div className="pull-right text-right">
                  {this.renderUnsaveWarningMessage(isDirty)}
                  {' '}
                  <Button className={((isDirty && isReady) ? 'animated flash' : '')} bsStyle="primary" disabled={!valid || submitting} type="submit">
                    {!submitting && <span>Save</span>}
                    {submitting && <span><Fa name="spinner" spin /> Saving</span>}
                  </Button>
                </div>
              }
            </div>
          </div>
          <div ref={(el) => { this.sentinalRef = el; }} />
        </div>
        <div style={{ height: '150px' }} />
      </form>
    );
  }

  render() {
    const { loading, loaded, errors } = this.state;
    const isLoading = loading || !loaded;

    return (
      <div>
        <Helmet title="Feedback Request Automations | Organization Setup" />
        {isLoading && <ProgressBar />}
        {!loading && !loaded && errors !== null && <Redirect to="/setup/feedback-requests/automations" />}
        {!isLoading && this.renderContent()}

        <AutomationTestModal
          open={this.state.runTest}
          onClose={() => { this.setState({ runTest: false }); }}
          settings={this.props.formValues}
          searchQuery={this.props.formInfos['automations/discovery-bot']?.query || {}}
          openWindowSearchQuery={this.props.formInfos['automations/discovery-bot/window']?.query || {}}
          isAccount={this.state.isAccount}
          contactQuery={this.props.contactQuery}
        />
      </div>
    );
  }
}

const selector = formValueSelector('discoveryBotsSettings'); // <-- same as form name

// Retrieve data from store as props
function mapStateToProps(state) {
  const enabled = selector(state, 'enabled');
  const automationType = selector(state, 'automation_type');
  const activityTypes = selector(state, 'full_automation_activity_types');
  const contactTypes = selector(state, 'full_automation_contact_types');
  const contactRoles = selector(state, 'full_automation_contact_roles');
  const contactReferenceFields = selector(state, 'full_automation_contact_reference_fields');
  const autoOpenRequestWindow = selector(state, 'auto_open_request_window') === 'true' || selector(state, 'auto_open_request_window') === true;
  const organization = getUserCurrentOrganization(state);
  return {
    enabled,
    automationType,
    activityTypes,
    contactRoles,
    contactReferenceFields,
    contactTypes,
    contactFromExternalAccount: selector(state, 'full_automation_contact_from_external_account'),

    formInfos: reduce(getValidFormNames(organization, autoOpenRequestWindow, automationType), (items, formName) => {
      items[formName] = {
        query: getSearchQuery(formName, state),
        isDirty: getIsDirty(formName, state),
      };
      return items;
    }, {}),

    autoOpenRequestWindow,
    sync: selector(state, 'sync'),
    footerHeight: getFooterHeight(state),
    ownerMustBeEnabled: selector(state, 'owner_must_be_enabled'),
    openWindowOwnerMustBeEnabled: selector(state, 'open_window_owner_must_be_enabled'),
    gongRequireOpportunityOwner: selector(state, 'gong_require_opportunity_owner'),
    bypassInvitation: selector(state, 'bypass_invitation'),
    formValues: getFormValues('discoveryBotsSettings')(state),
    syncLookback: selector(state, 'syncLookback'),
    selectedInstructions: selector(state, 'instructions'),
    selectedTVCollectorId: selector(state, 'tv_collector_id'),
    opportunityContactTypes: selector(state, 'full_automation_opportunty_contact_types'),
    opportunityStatus: selector(state, 'opportunity_status'),
    senderConditions: selector(state, 'sender_conditions'),
    resellers: selector(state, 'resellers'),
    syncLookbackPeriod: selector(state, 'sync_lookback_period'),
    syncLookbackUnit: selector(state, 'sync_lookback_unit'),
    fullAutomationSingleOpportunity: selector(state, 'full_automation_single_opportunity'),
    contactConditions: selector(state, 'contact_conditions'),
    opportunityFromExternalOwner: selector(state, 'full_automation_opportunity_from_external_owner'),
    isDeleted: selector(state, 'is_deleted'),
    organization,
  };
}

FeedbackRequestAutomationPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  dirty: PropTypes.bool,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  reset: PropTypes.func,
  error: PropTypes.string,
  change: PropTypes.func,
  valid: PropTypes.bool,
  enabled: PropTypes.bool,
  automationType: PropTypes.string,
  syncLookback: PropTypes.string,
  activityTypes: PropTypes.arrayOf(PropTypes.string),
  contactRoles: PropTypes.arrayOf(PropTypes.string),
  contactReferenceFields: PropTypes.arrayOf(PropTypes.string),
  contactTypes: PropTypes.arrayOf(PropTypes.string),
  contactFromExternalAccount: PropTypes.bool,
  opportunityFromExternalOwner: PropTypes.bool,
  autoOpenRequestWindow: PropTypes.bool,
  sync: PropTypes.bool,
  footerHeight: PropTypes.number,
  ownerMustBeEnabled: PropTypes.bool,
  openWindowOwnerMustBeEnabled: PropTypes.bool,
  bypassInvitation: PropTypes.bool,
  validCollectors: PropTypes.arrayOf(PropTypes.shape({})),
  formValues: PropTypes.shape({}),
  selectedInstructions: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  selectedTVCollectorId: PropTypes.string,
  opportunityContactTypes: PropTypes.string,
  opportunityStatus: PropTypes.arrayOf(PropTypes.string),
  senderConditions: PropTypes.arrayOf(PropTypes.shape({})),
  resellers: PropTypes.arrayOf(PropTypes.shape({})),
  syncLookbackPeriod: PropTypes.number,
  syncLookbackUnit: PropTypes.string,
  fullAutomationSingleOpportunity: PropTypes.bool,
  gongRequireOpportunityOwner: PropTypes.bool,
  contactConditions: PropTypes.arrayOf(PropTypes.shape({})),
  formInfos: PropTypes.shape(reduce(formNames, (items, formName) => {
    items[formName] = PropTypes.shape({
      query:  PropTypes.shape({}),
      isDirty:  PropTypes.bool,
    });
    return items;
  }, {})),
  organization: PropTypes.shape({
    _id: PropTypes.string,
    has_gong_contacts: PropTypes.bool,
  }).isRequired,
  isDeleted: PropTypes.bool,
  sessionId: PropTypes.string,
};
FeedbackRequestAutomationPage.defaultProps = {
  submitting: false,
  dirty: false,
  handleSubmit: () => {},
  initialize: () => {},
  reset: () => {},
  change: () => {},
  error: null,
  enabled: false,
  valid: false,
  contactFromExternalAccount: false,
  opportunityFromExternalOwner: false,
  activityTypes: [],
  contactRoles: [],
  contactTypes: [],
  automationType: 'manual',
  autoOpenRequestWindow: false,
  sync: false,
  footerHeight: 0,
  ownerMustBeEnabled: false,
  openWindowOwnerMustBeEnabled: false,
  bypassInvitation: false,
  validCollectors: [],
  formValues: {},
  syncLookback: '1 weeks',
  selectedInstructions: null,
  selectedTVCollectorId: null,
  opportunityContactTypes: 'roles-and-primary',
  opportunityStatus: ['closed'],
  senderConditions: [],
  syncLookbackPeriod: 1,
  syncLookbackUnit: 'days',
  contactConditions: [],
  resellers: [],
  formInfos: {},
  fullAutomationSingleOpportunity: false,
  isDeleted: false,
  sessionId: null,
};
FeedbackRequestAutomationPage.contextTypes = {
  addNotification: PropTypes.func.isRequired,
  router: PropTypes.shape({}).isRequired,
};

const validate = (data) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   full_automation_activity_threshold: {
  //     presence: true,
  //     numericality: { greaterThanOrEqualTo: 0, strict: true, onlyInteger: true },
  //   },
  //   full_automation_contact_types: {
  //     presence: {
  //       allowEmpty: false,
  //       message: '^Please select at least one "Contact Type" option for the contact submit conditions.',
  //     },
  //     type: {
  //       type: (value) => {
  //         return isArray(value);
  //       },
  //     },
  //   },
  //   source: {
  //     presence: true,
  //     inclusion: {
  //       within: ['opportunity', 'account'],
  //       message: '^Invalid automation type of %{value}',
  //     },
  //   },
  //   ...(data.source === 'account' ? {
  //     sync_lookback_period: {
  //       presence: true,
  //       numericality: {
  //         onlyInteger: true,
  //         greaterThan: 0,
  //       },
  //     },
  //   } : {}),
  // };

  const baseSchema = {
    full_automation_activity_threshold: Joi.number().integer().min(0).required().messages({
      'number.base': 'Activity threshold must be a number',
      'number.integer': 'Activity threshold must be an integer',
      'number.min': 'Activity threshold must be at least 0',
      'any.required': 'Activity threshold is required',
    }),
    full_automation_contact_types: Joi.array().min(1).required().messages({
      'array.base': 'Contact types must be an array',
      'array.min': 'Please select at least one "Contact Type" option for the contact submit conditions.',
      'any.required': 'Contact types are required',
    }),
    source: Joi.string().valid('opportunity', 'account').required().messages({
      'string.base': 'Source must be a string',
      'any.only': 'Invalid automation type',
      'any.required': 'Source is required',
    }),
  };

  if (data.source === 'account') {
    baseSchema.sync_lookback_period = Joi.number().integer().greater(0).required().messages({
      'number.base': 'Lookback period must be a number',
      'number.integer': 'Lookback period must be an integer',
      'number.greater': 'Lookback period must be greater than 0',
      'any.required': 'Lookback period is required',
    });
  }

  const schema = Joi.object(baseSchema).unknown(true);
  const { error } = schema.validate(data, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const FeedbackRequestAutomationForm = reduxForm({
  form: 'discoveryBotsSettings',
  validate,
}, { touchOnChange: true })(FeedbackRequestAutomationPage);

export default connect(mapStateToProps)(FeedbackRequestAutomationForm);
